<div
  *ngIf="buildingSection; else nobuildingSection"
  [nbPopover]="popover"
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'bottom'">
  {{buildingSection.sectionText}}
</div>

<ng-template #nobuildingSection>
  <div class="no-buildingSection">kein Gebäudeteil</div>
</ng-template>

<ng-template #popover>
  <wr-building-section-popover [buildingSection]="buildingSection" [disableLink]="disableLink"></wr-building-section-popover>
</ng-template>
